<template>
  <div class="container-avise" v-if="showAlert">
    <div class="container-img">
        <img class="img-avise" src="https://d1mq21xo4bjiqa.cloudfront.net/images-portal-tutores/Alert_02/Alert_02.png"
            alt="aviso_bienestar_azteca">
    </div>
    <div class="container-msg">
      <p class="msg-avise" v-html="props.modelAvise.text">
      </p>
    </div>
    <div class="container-close-icon" @click="closeAvise()" @keydown="closeAvise()">
        <img class="close-icon" src="@/assets/icons/close.png" alt="close_modal">
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  modelAvise: Object,
});

const showAlert = ref(true);
const closeAvise = () => {
  showAlert.value = false;
};

</script>
<style scoped>
.container-avise {
  width: 80%;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.container-avise .container-img {
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto
}

.container-avise .container-img .img-avise {
  height: auto;
  min-height: 20px;
  max-height: 60px;
  width: auto;
  min-width: 20px;
  max-width: 60px;
}

.container-avise .container-msg {
  width: 80%;
  border-radius: 10px;
  box-shadow: 0px 2px 2px rgba(0, 154, 189, 0.3);
  min-height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 10px 10px 20px;
  margin-left: -20px;
}

.container-avise .container-close-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: auto;
  margin-top: -10px;
  margin-left: -13px;
  min-width: 20px;
  max-width: 24px;
  width: auto;
  min-height: 20px;
  max-height: 24px;
  height: auto;
  border-radius: 10px;
  cursor: pointer;
}

.container-avise .container-close-icon .close-icon {
  min-width: 20px;
  max-width: 24px;
  width: auto;
  min-height: 20px;
  max-height: 24px;
  height: auto;
  cursor: pointer;
}

.container-avise .container-msg .msg-avise {
  font-size: 20px;
  text-align: justify;
  margin-left: 5px;
}

@media only screen and (min-width: 200px) and (max-width: 530px) {
  .container-avise .container-msg .msg-avise {
    font-size: 12px !important;
  }
}

@media only screen and (min-width: 350px) and (max-width: 400px) {
  .container-avise .container-msg .msg-avise {
    font-size: 12px !important;
  }
}

@media only screen and (min-width: 567px) and (max-width: 1025px)
and (min-height: 200px) and (max-height: 730px)
and (orientation: landscape) {
  .container-msg .msg-avise {
    font-size: 14px !important;
  }
}

</style>
